import React, { useEffect } from "react";
import { APIProvider, Map, Marker, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";

function Route({ home, stores }) {
  const map = useMap();
  const routes = useMapsLibrary("routes");
  useEffect(() => {
    if (!map || !routes || !stores.length) { return undefined; }
    const renderer = new routes.DirectionsRenderer({ map, suppressMarkers: true, polylineOptions: { strokeColor: "#075B3A", strokeWeight: 5 } });
    new routes.DirectionsService().route({
      origin: { lat: home[0], lng: home[1] }, destination: { lat: home[0], lng: home[1] },
      waypoints: stores.map((s) => ({ location: { lat: s.lat, lng: s.lng }, stopover: true })),
      travelMode: "DRIVING",
    }).then((r) => renderer.setDirections(r)).catch(() => {});
    return () => renderer.setMap(null);
  }, [map, routes, home, stores]);
  useEffect(() => {
    if (!map || !window.google) { return; }
    const b = new window.google.maps.LatLngBounds();
    b.extend({ lat: home[0], lng: home[1] });
    stores.forEach((s) => b.extend({ lat: s.lat, lng: s.lng }));
    map.fitBounds(b, 48);
  }, [map, home, stores]);
  return null;
}

export default function GoogleMapView({ apiKey, stores, home, height }) {
  return (
    <div data-testid="route-map" style={{ height }} className="w-full rounded-2xl overflow-hidden border border-pp-border">
      <APIProvider apiKey={apiKey}>
        <Map defaultCenter={{ lat: home[0], lng: home[1] }} defaultZoom={11} gestureHandling="cooperative"
          mapTypeControl={false} streetViewControl={false} fullscreenControl={false}>
          <Marker position={{ lat: home[0], lng: home[1] }} label={{ text: "H", color: "#fff", fontWeight: "800" }} title="Home" />
          {stores.map((s, i) => (
            <Marker key={s.store_id || i} position={{ lat: s.lat, lng: s.lng }} title={s.name}
              label={{ text: String(i + 1), color: "#fff", fontWeight: "800" }} />
          ))}
          <Route home={home} stores={stores} />
        </Map>
      </APIProvider>
    </div>
  );
}
